import { SWRConfiguration } from 'swr';

export const swrConfig: SWRConfiguration = {
  // Revalidation settings
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  revalidateIfStale: true,
  
  // Retry settings
  shouldRetryOnError: true,
  errorRetryCount: 3,
  errorRetryInterval: 5000,
  
  // Dedupe settings
  dedupingInterval: 2000,
  
  // Cache settings
  focusThrottleInterval: 5000,
  
  // Global error handler
  onError: (error, key) => {
    if (error.status === 401) {
      // Handle unauthorized errors globally
      console.error('Unauthorized access:', key);
      // Could redirect to login here
    }
  },
  
  // Global success handler
  onSuccess: (data, key) => {
    console.debug('SWR fetch success:', key);
  },
};